export enum FieldNames {
  FormCategories = 'formCategories',
}
